import { Calendar } from '@microsoft/fast-foundation';
import { baseDateFormatter } from './baseDateFormatter';
export class baseCalendar extends Calendar {
    constructor() {
        super(...arguments);
        this.dateFormatter = new baseDateFormatter();
    }
}
